/**
 * Vuex 4 compatibility store that delegates entirely to Pinia stores.
 *
 * Vuex 4 getters use Vue 3 reactivity — reading Pinia refs inside a getter
 * creates a reactive dependency, so the getter re-evaluates automatically
 * when Pinia state changes. This means old views using `this.$store.getters.*`
 * and `this.$store.dispatch(...)` stay consistent with new Pinia-based code.
 *
 * Remove this file once P1 component migration is complete.
 */
import { createStore } from 'vuex'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import { useRegionStore } from '@/stores/region'

export const store = createStore({
  // No local state — single source of truth lives in Pinia
  state: () => ({}),

  getters: {
    isSignedIn: () => useAuthStore().isSignedIn,
    user: () => useAuthStore().user,
    isCorporate: () => useAuthStore().isCorporate,
    isFederated: () => useAuthStore().isFederated,
    isAdmin: () => useAuthStore().isAdmin,
    isManager: () => useAuthStore().isManager,
    hasAnyRolAdmin: () => useAuthStore().hasAnyRoleAdmin,
    apps: () => useAppStore().apps,
    regions: () => useRegionStore().regions,
    region: () => useRegionStore().region,
    regionLocked: () => useRegionStore().regionLocked,
  },

  actions: {
    changeRegion(_, region: string) {
      useRegionStore().changeRegion(region)
    },
    lockRegion() {
      useRegionStore().lockRegion()
    },
    unlockRegion() {
      useRegionStore().unlockRegion()
    },
  },
})
